import { BebyggelseobjektUtkast, HTTP_STATUS, PatchReservation } from 'models';

import { bebyggelseApiRTK } from 'api/bebyggelseApiRTK';

type ExtendedBebyggelseobjektUtkast = BebyggelseobjektUtkast & { http_status_code: HTTP_STATUS };

export const reservationSlice = bebyggelseApiRTK.injectEndpoints({
  endpoints: (build) => ({
    reserveBebyggelseutkast: build.mutation<ExtendedBebyggelseobjektUtkast, PatchReservation>({
      transformErrorResponse(baseQueryReturnValue) {
        return {
          ...baseQueryReturnValue
        };
      },
      transformResponse: (response: any, meta) => {
        return {
          http_status_code: meta?.response?.status,
          ...response
        };
      },
      query: ({ id, reserve }) => ({
        url: `bebyggelseobjekt/utkast/${id}/reservation`,
        method: 'PATCH',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ reservation: reserve })
      })
    })
  })
});

export const { useReserveBebyggelseutkastMutation } = reservationSlice;
